/* eslint-disable react/jsx-pascal-case */
import {
    Row,
    Col,
    Modal,
    Button,
    Form,
} from "../../ui/ot";

import React, {
    useContext,
    useEffect,
    useRef,
    lazy,
    Suspense,
    useState,
} from "react";
import PageBlogForm from "./page_blog_form";

const PageBlogModal = ({
    axiosMode = "patch",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => { },
    onFinish = () => { },
    editcard,
    propertyJsonShow
}) => {
    const axiosModelanguage = {
        post: "新增",
        patch: "編輯",
    };
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formReloadCount, setFormReloadCount] = useState(0);
    const showModal = () => {
        setFormReloadCount((pre) => pre + 1);
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
        setLoading(false);

    };

    const handleOk = () => {
        setLoading(true);
        if (propsForm) {
            propsForm.submit();
        } else {
            form.submit();
        }
        closeModal()
    };

    const handleCancel = () => {
        closeModal();
    };
    const onFormFinish = (values) => {
        onFinish(values);
    };
    useEffect(() => {
        // setFormReloadCount((pre) => pre + 1);
    }, [propsOpen]);
    return (
        <>
            {propsOpen === null && (
                <Button type="primary" onClick={showModal}>
                    {`區塊${axiosModelanguage[axiosMode]}`}
                </Button>
            )}

            <Modal
                style={{}}
                title={`區塊${axiosModelanguage[axiosMode]}`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                contentStyle={{
                    padding: 16,
                    align:"top",
                    minHeight: "75vh",

                }}
                width={"98vw"}
                okText={"送出"}
                cancelText={"取消"}
            >
                <Row
                    style={{
                        maxHeight: "80vh",
                        overflowX: "scroll",
                        overflowY: "scroll",
                    }}
                    gutter={[8, 8]}
                >
                    <Col span={24}>
                    </Col>
                    <Col span={24}>
                        <PageBlogForm
                            propertyJsonShow={propertyJsonShow}
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default PageBlogModal;
